import { createFileRoute } from '@tanstack/react-router';
import { LoginSecuritySettingsPage } from '@/pages/super-admin/login-security/LoginSecuritySettingsPage';

export const Route = createFileRoute('/_authenticated/super-admin/login-security/settings')({
	component: LoginSecuritySettingsPage,
});
